type SavedAssetConfiguration = {
  productId?: string;
  metadata?: {
    objectActiveParams?: { activeTab?: string };
  };
};

/** Resolves collection alternatives to the single asset UUID required by the Threekit player. */
export function resolvePlayerAssetId(
  assetId: string | readonly string[] | null | undefined,
  savedConfiguration?: SavedAssetConfiguration | null
): string {
  let resolved: string | undefined;

  if (Array.isArray(assetId)) {
    const productId = savedConfiguration?.productId;
    const activeTab = savedConfiguration?.metadata?.objectActiveParams?.activeTab;
    resolved = productId && assetId.includes(productId)
      ? productId
      : assetId[activeTab === "Headboards Only" ? 1 : 0];
  } else {
    resolved = typeof assetId === "string" && assetId ? assetId : savedConfiguration?.productId;
  }

  if (!resolved || typeof resolved !== "string" || resolved.includes(",")) {
    throw new Error("A single Threekit player asset ID is required");
  }

  return resolved;
}
